// Example: How to integrate StartMessageModal into a User Profile Page
// This is a reference implementation - adapt to your existing profile page

import React, { useState } from 'react';
import { Head } from '@inertiajs/react';
import StartMessageModal from '@/Pages/Chat/StartMessageModal';

export default function UserProfile({ user }) {
    const [showMessageModal, setShowMessageModal] = useState(false);

    return (
        <>
            <Head title={`${user.name}'s Profile`} />
            
            <div className="container py-5">
                <div className="row">
                    <div className="col-md-8 mx-auto">
                        {/* User Profile Header */}
                        <div className="card mb-4">
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <img 
                                        src={`https://i.pravatar.cc/150?u=${user.id}`}
                                        alt={user.name}
                                        className="rounded-circle me-3"
                                        style={{ width: '100px', height: '100px' }}
                                    />
                                    <div className="flex-grow-1">
                                        <h2 className="mb-1">{user.name}</h2>
                                        <p className="text-muted mb-2">{user.email}</p>
                                        
                                        {/* Message Button */}
                                        <button 
                                            className="btn btn-primary"
                                            onClick={() => setShowMessageModal(true)}
                                        >
                                            <i className="bi bi-envelope me-2"></i>
                                            Send Message
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Rest of profile content */}
                        <div className="card">
                            <div className="card-header">
                                <h4>About</h4>
                            </div>
                            <div className="card-body">
                                {/* User details, bio, etc. */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Message Modal */}
            <StartMessageModal
                show={showMessageModal}
                handleClose={() => setShowMessageModal(false)}
                recipientId={user.id}
                recipientName={user.name}
            />
        </>
    );
}
